module.exports = __webpack_public_path__ + "img/news_hola.4c581790.svg";